function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "square",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.491 47c0-6.7 5.432-12.132 12.132-12.132S40.755 40.3 40.755 47"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.868 47c0-9.253 7.501-16.755 16.755-16.755S45.378 37.746 45.378 47"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.246 47c0-11.806 9.57-21.377 21.377-21.377S50 35.193 50 47"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.624 47c0-14.359 11.64-25.999 25.999-25.999S54.622 32.641 54.622 47"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.624 47c0-14.359 11.64-25.999 25.999-25.999S54.622 32.641 54.622 47M42.791 8.227a5.885 5.885 0 00-5.486 3.758 4.006 4.006 0 00-.09 0 4.006 4.006 0 00-4.007 4.005 4.006 4.006 0 004.006 4.006 4.006 4.006 0 002.495-.871 5.885 5.885 0 003.082.871 5.885 5.885 0 002.779-.697 5.063 5.063 0 002.563.697 5.063 5.063 0 005.064-5.062 5.063 5.063 0 00-5.064-5.064A5.063 5.063 0 0047 10a5.885 5.885 0 00-4.209-1.773z"
}));

var SvgRainbow = function SvgRainbow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRainbow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Rainbow.d06c1ce3.svg";
export { ForwardRef as ReactComponent };